import React from 'react';
import ReportingFinancesPayoutsPage from '../components/ReportingFinancesPayoutsPage';

const ReportingFinancesPayoutsApp = (props) => (
  <ReportingFinancesPayoutsPage {...props} />
);

export default ReportingFinancesPayoutsApp;
